import React, { Component } from "react";
import "../Styles/Explore.css";

class Explore extends Component {
  render() {
    return (
      <div id="explore">
        <h1>Explore</h1>
        <div className="explore-container">
          <div className="explore-intro-1">
            Explore is an invitation to delve into the unknown, fostering
            curiosity and the desire for discovery. It encapsulates the essence
            of venturing beyond boundaries, whether physical or intellectual, to
            seek new experiences, knowledge, and perspectives. This succinct
            phrase embodies the thrill of exploration, urging individuals to
            embrace the unfamiliar and uncover hidden gems. It evokes a sense of
            wonder and curiosity, inspiring a journey towards continuous
            learning, growth, and the unearthing of new possibilities{" "}
          </div>
          <div className="explore-intro-2">
            Exploration of the unknown is the genesis of authentic living, where
            every step into uncharted territories breathes life into existence.
            It’s in these unexplored realms that the essence of true vitality
            thrives, as each discovery and newfound path infuses the soul with
            an invigorating energy.{" "}
          </div>
        </div>
        <h2>Religious Place</h2>
        <div className="religion">
          <div>
            <img
              src="https://i0.wp.com/alpineclubofhimalaya.com/wp-content/uploads/2020/05/manakamana-1-1024x768-2.jpg?fit=910%2C683&ssl=1"
              alt=""
            ></img>
            <h3>Manakamana</h3>
          </div>

          <div>
            <img
              src="https://ktmguide.com/wp-content/uploads/2019/10/14663114480_6f3a4dd9c2_o-scaled.jpg"
              alt=""
            ></img>
            <h3>Kalinchwok</h3>
          </div>
          <div>
            <img
              src="https://www.tusktravel.com/blog/wp-content/uploads/2020/12/List-of-7-Best-Religious-Holy-Places-to-Visit-in-Nepal.jpg"
              alt=""
            ></img>
            <h3>Swyambu</h3>
          </div>
          <div>
            <img
              src="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/13/4a/95/ac/pashupatinath-is-the.jpg?w=500&h=400&s=1"
              alt=""
            ></img>
            <h3>Pasupatinath</h3>
          </div>
          <div>
            <img
              src="https://admin.buddhaair.com/photos/3/muktinath%20buddha%20air%20blog.jpg"
              alt=""
            ></img>
            <h3>Mukthinath</h3>
          </div>
          <div>
            <img
              src="https://img.atlasobscura.com/yO2X4xn2SBePMRj8kZXOd7YTnSTD5njKAoWRKjsMLdI/rs:fill:580:580:1/g:ce/q:81/sm:1/scp:1/ar:1/aHR0cHM6Ly9hdGxh/cy1kZXYuczMuYW1h/em9uYXdzLmNvbS91/cGxvYWRzL3BsYWNl/X2ltYWdlcy9lMGU0/MTFiNy0zNzI3LTQx/NjAtOGU0MC1jODJj/Y2U5ZjgyMDFmMjRk/YjBmODE4MWJjNGJj/YjVfODAwcHgtQmlz/a2V0X0phdHJhX2Zl/c3RpdmFsXzIwMThf/YXRfdGhlX055YXRh/cG9sYV90ZW1wbGUs/X0JoYWt0YXB1ci5q/cGc.jpg"
              alt=""
            ></img>
            <h3>Natyapol</h3>
          </div>
          <div>
            <img
              src="https://www.nepal-travel-guide.com/wp-content/uploads/2020/06/viber_image_%E0%A5%A8%E0%A5%A6%E0%A5%A8%E0%A5%A6-%E0%A5%A6%E0%A5%AC-%E0%A5%A6%E0%A5%A9_%E0%A5%A7%E0%A5%AE-%E0%A5%A9%E0%A5%AA-%E0%A5%A6.jpg"
              alt=""
            ></img>
            <h3>Badimalika</h3>
          </div>
          <div>
            <img
              src="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/16/a9/7a/fb/the-beautiful-janaki.jpg?w=500&h=-1&s=1"
              alt=""
            ></img>
            <h3>Janakimandir</h3>
          </div>
        </div>
        <h2>Heritage sites</h2>
        <div className="heritage">
            <div>
                <img src="https://hsj.com.np/uploads/0000/1/2023/08/06/bhaktapur-rainy.jpg" alt=""></img>
                <h3>Bhaktapur Durbar Square</h3>
                <p>The Bhaktapur Durbar square is the last of the 3 old palaces of Kathmandu. Bhaktapur, also known as Khwopa or Bhadgaon is a medieval city located around 12 km east of Kathmandu. The Durbar Square here is one of the best showcases of Nepali architecture and craftsmanship. The four squares – Durbar Square, Taumadhi Square, Dattatreya Square, and Pottery Square collectively make up the Bhaktapur Durbar square. The most notable landmarks and monuments include the Lions Gate, Golden Gate, Art Gallery, Statue of King Bhupatindra, Nyatapola Temple and fifty-five windowed Malla palace.</p>
            </div>
            <div>
                <img src="https://www.adventurehimalayacircuit.com/blog/wp-content/uploads/2020/02/Patan-Durbar-Square.jpg" alt=""></img>
                <h3>Patan Durbar Square</h3>
                <p>Similar to the Kathmandu Durbar, the Patan Durbar Square is the old palace of the kingdom of Patan/Lalitpur. People believe that the town was named after King Yalamber, as Patan also translates to Yala. It is located around 8 km south-east of central Kathmandu. This palace complex is an excellent showcase of Newari architecture and craftsmanship. The courtyard is dotted with a number of Hindu as well as Buddhist monuments. Historical records have shown that Emperor Ashoka built parts of this Square way back in the 3rd century BCE.</p>
            </div>
            <div>
                <img src="https://www.adventurehimalayacircuit.com/blog/wp-content/uploads/2020/02/Kathmandu-Durbar-Square.jpg" alt=""></img>
                <h3>Kathmandu Durbar Square</h3>
                <p>Also known as the Hanuman Dhoka Palace, the Kathmandu Durbar Square is one of the three durbar squares in the Kathmandu Valley. This was the old royal palace and courtyard of the Mallas and Shahs of Kathmandu with a plethora of temples and shrines. The main palace complex was constructed as early as the 15th century while additional buildings and monuments were added as time went on. The notable things to explore here include the namesake monument Hanuman Dhoka, Taleju Mandir, Nine storey Basantapur Tower, Sundari Chowk, Tribhuvan Museum, King Mahendra Memorial Museum and Kal Bhairab temple in its vicinity.</p>
            </div>
            <div>
                <img src="https://www.adventurehimalayacircuit.com/blog/wp-content/uploads/2020/02/Boudhanath-Stupa.jpg" alt=""></img>
                <h3>Baudha Stupa</h3>
                <p>If Pashupatinath is the holiest Hindu temple in Kathmandu, then its Buddhist counterpart has to be the Boudhanath Stupa. There are a number of Newar as well as Tibetan Buddhist myths and legends surrounding this amazing stupa’s origin while some records state that it was built by a Licchavi King Sivadeva as far back as the 5th Century CE. In present day, it is one of the largest Buddhist stupas in the world and the whole surrounding area is a Buddhist-populated settlement with over 40 monasteries nearby. A large number of tourists, pilgrims as well as locals visit the Stupa every day, each for their own reasons. Chanting monks, spinning prayer wheels, flocks of pigeons, and the smell of incense are just a few factors that make up the unique atmosphere of this location.</p>
            </div>
            <div>
                <img src="https://www.adventurehimalayacircuit.com/blog/wp-content/uploads/2020/02/Pashupatinath-Temple.jpg" alt=""></img>
                <h3>Pasupatinath Temple</h3>
                <p>Heritage tour in Nepal. One of the most sacred Hindu temples in the world, Pashupatinath is a millennia old temple dedicated to Lord Shiva. The temple complex consists of the main temple and compound, surrounded by a variety of smaller temples, ashrams and sculptures and is bordered by the holy Bagmati River to the east. Entry to the main temple is allowed only for Hindus but everyone is free to observe from the hills beside the Bagmati riverbanks. Observing the various rituals, ceremonies as well as funeral is a fascinating experience for tourists. A testament to the importance of this temple is the sheer amount of pilgrims it attracts, particularly during the holy occasions like Teej and Shivaratri where visitors number to hundreds of thousands in a single day..</p>
            </div>
            <div>
                <img src="https://www.adventurehimalayacircuit.com/blog/wp-content/uploads/2020/02/Lumbini.jpg" alt=""></img>
                <h3>Lumbini</h3>
                <p>Situated around 300 kilometers south west of Kathmandu in the plains of Terai, Lumbini is a religious pilgrimage destination with a lot of history behind it. It was the last of the 4 locations in Nepal to be designated as a UNESCO World Heritage Site (1997). Lumbini is best known as the birthplace of Gautama Buddha. Also known as Siddhartha Gautama or Shakyamuni, Buddha was a Shakya prince from around 3rd – 4th century BCE that spent decades in self-imposed exile and eventually attained enlightenment to become the Buddha. His teaching came to be known as Buddhism and spread all over the world through the years. As such, Lumbini is an immensely important religious site for Buddhists..</p>
            </div>
            <div>
                <img src="https://www.adventurehimalayacircuit.com/blog/wp-content/uploads/2019/09/Climbing-Adventure-to-the-Island-Peak-e1581060486391.jpg" alt=""></img>
                <h3>Sagarmatha National Park</h3>
                <p>Sagarmatha National Park, which is the second National Park of Nepal, being established in the year 1976. Just 3 years after its creation, it was designated as a UNESCO World Heritage Site, owing to the immense amounts of cultural and natural wealth of this region. The most recognizable part of the Sagarmatha National Park would most certainly be Sagarmatha, or Mount Everest, which is the highest peak in the world at 8,848m. Aside from Everest, the region is also home to some of the highest peaks in the world along with stunning glaciers, valleys, rivers and mountains. The park itself stretches over an area of 1,148 sq. km. It is home to a diverse variety of Himalayan flora and fauna including rhododendrons, blue pine, silver fir and birch among others.</p>
            </div>
        </div>
        <h2>Daring To Do</h2>
        <div className="todo">
            <div>
                <img src="https://www.thelastresort.com.np/wp-content/uploads/2019/11/Bungy-jump.jpg" alt=""></img>
                <h3>Bhotekosi Bungi</h3>
            </div>
            <div>
                <img src="https://www.sevensummittreks.com/uploads/original/1653287230_ebc-c5hp0XiZDKvr6pLMNSUCPm0ibYD9kQnZDoIR3DU8.jpg" alt=""></img>
                <h3>EBC Trek</h3>
            </div>
            <div>
                <img src="https://www.trekdreamnepal.com/wp-content/uploads/sites/2065/2019/08/trek-annapurna-abc-agence-circuit-nepal.jpg" alt=""></img>
                <h3>ABC Circuit</h3>
            </div>
            <div>
                <img src="https://www.vivaanadventure.com/wp-content/uploads/2020/03/Bungee-Jump-Kushma-.jpg" alt=""></img>
                <h3>Kusma Swing</h3>
            </div>
            <div>
                <img src="https://cdn.kimkim.com/files/a/images/0e0350802029b14da46c5162c2e6227458751a63/big-779eb8833d6ab03cd63f1c59d4fb9b3d.jpg" alt=""></img>
                <h3>Tilicho lake trek</h3>
            </div>
            <div>
                <img src="https://cdn.bookatrekking.com/data/images/2019/11/manaslu-circuit-trek-all-you-need-to-know1.jpg" alt=""></img>
                <h3>Manaslu circuit</h3>
            </div>
            <div>
                <img src="https://www.greatnepaltreks.com/wp-content/uploads/2019/11/Chitwan-Jungle-Safari-Package.jpg" alt=""></img>
                <h3>Jungle Safari</h3>
            </div>
        </div>
      </div>
    );
  }
}

export default Explore;
